import React, { useState, useEffect } from 'react';
import './VideoPopUp.css';

// interface VideoPopUpProps {
//   url: string | string[]; // Can accept single URL or array of URLs
// }

const VideoPopUp = ({ url, setVideoPopupIndex, videoPopupIndex, getPlaybackRate }: any) => {
  const videoRef = React.useRef<HTMLVideoElement | null>(null);
  const [currentIndex, setCurrentIndex] = useState(videoPopupIndex);
  const [mediaUrls, setMediaUrls] = useState<string[]>([]);
  const [isOpen, setIsOpen] = useState(true);
  const [currentUrl, setCurrentUrl] = useState(null);

  useEffect(() => {
    if (typeof url === 'string') {
      setMediaUrls([url]);
    } else if (Array.isArray(url)) {
      setMediaUrls(url);
    }
  }, [url]);

  const handleClose = () => {
    setVideoPopupIndex(null);
    setIsOpen(false);
  };

  const handleNext = () => {
    setCurrentIndex(prev => (prev + 1) % mediaUrls.length);
  };

  const handlePrevious = () => {
    setCurrentIndex(prev => (prev - 1 + mediaUrls.length) % mediaUrls.length);
  };

  useEffect(() => {
    setCurrentUrl(mediaUrls[currentIndex]);
  }, [currentIndex, mediaUrls]);

  // Re-apply the rate when it resolves after the clip already loaded.
  useEffect(() => {
    const el = videoRef.current;
    if (!el || !currentUrl || !getPlaybackRate) {
      return;
    }
    const rate = getPlaybackRate(currentUrl);
    if (typeof rate === 'number' && rate > 0) {
      el.playbackRate = rate;
    }
  }, [currentUrl, getPlaybackRate]);

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'ArrowRight') {
        handleNext();
      } else if (event.key === 'ArrowLeft') {
        handlePrevious();
      } else if (event.key === 'Escape') {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [mediaUrls]);

  if (!isOpen || mediaUrls.length === 0) {
    return null;
  }

  // const currentUrl = mediaUrls[currentIndex];
  // const isVideo = currentUrl?.endsWith('.webm') || currentUrl?.endsWith('.mp4');

  return (
    <div className="video-popup-overlay">
      <div className="video-popup-content">
        <div
          className="media-container"
          style={{ width: '50vw' }}
        >
          <button
            className="video-popup-close-button"
            onClick={handleClose}
            aria-label="Close popup" // Accessibility improvement
          >
            ×
          </button>

          {currentUrl?.endsWith('.webm') || currentUrl?.endsWith('.mp4') ? (
            <video
              ref={videoRef}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              key={currentUrl}
              controls
              autoPlay
              className="media-content"
              loop
              onLoadedData={e => {
                if (getPlaybackRate) {
                  const rate = getPlaybackRate(currentUrl);
                  if (typeof rate === 'number' && rate > 0) e.currentTarget.playbackRate = rate;
                }
              }}
            >
              <source
                src={currentUrl}
                type="video/webm"
              />
              Your browser does not support video.
            </video>
          ) : (
            <img
              src={currentUrl}
              alt="Media content"
              className="media-content"
            />
          )}

          {mediaUrls.length > 1 && (
            <div className="video-navigation">
              <button
                onClick={handlePrevious}
                className="nav-button prev"
              >
                <span className="arrow">{'<'}</span>
              </button>
              <button
                onClick={handleNext}
                className="nav-button next"
              >
                <span className="arrow">{'>'}</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoPopUp;
